var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"sso-login-btn",attrs:{"loading":_vm.loading,"disabled":_vm.disabled,"block":"","large":"","outlined":"","color":"primary"},on:{"click":_vm.handleClick}},[_c('v-icon',{attrs:{"left":"","color":"blue"}},[_vm._v("mdi-microsoft")]),_c('span',[_vm._v(_vm._s(_vm.displayName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }